import { IAssociation } from './@association';
import { IOrganisation } from './@organisation';
import { ITeam } from './@team';

export interface IEventState {
  all: IEvent[] | [];
  eventCreate: IEventCreate;
  isLoaded: { organisations: boolean };
  isCreated: boolean;
  pages: number | undefined;
}

export interface IEventCreate {
  association: IAssociation;
  organisation: IOrganisation;
  team: ITeam;
  eventForm: IEventCreateForm;
}

export interface IEvent {
  _id?: string;
  name: string;
  slogan?: string;
  twitterId?: string;
  instagramId?: string;
  tiktokId?: string;
  link?: string;
  eventCategory?: string;
  contextType?: string;
  activityKey?: string;
  gameType?: string;
}

export interface IEventCreateForm {
  name: string;
  slogan: string;
  twitterId: string;
  instagramId: string;
  tiktokId: string;
  link: string;
  eventCategory: string;
  contextType: string;
  activityKey: string;
  locale: string;
}

export interface IEventPutPayload {
  [key: string]: any;
}

export type TEventGetAllPayload = number | undefined;

export interface IEventGetResponseOk {
  data: IEvent[];
  pages: number;
}

export interface IEventPutResponseOk extends IEvent {}

export enum EEventCreateSteps {
  type = 0,
  association = 1,
  organisation = 2,
  team = 3,
  event = 4,
}